import React, { useRef, useEffect } from 'react';
import Modal from 'react-modal';
import SignaturePad from 'react-signature-canvas';

const SignatureModal = ({ value, onClose, handleSave }) => {
  const sigPad = useRef();

  useEffect(() => {
    if (sigPad.current) {
      if (value) {
        sigPad.current.fromDataURL(value);
      }
    }
  }, [sigPad]);

  return (
    <Modal className="modal-default" isOpen onRequestClose={onClose} contentLabel="Signature Modal" ariaHideApp={false}>
      <h2 className="modal-header">
        <span>Signature</span>
        <button className="btn btn-icon" onClick={onClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div className="modal-body">
        <div className={`sigCanvas-wrapper`}>
          <SignaturePad ref={sigPad} penColor="black" clearOnResize={false} canvasProps={{ className: `sigCanvas` }} />
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-outline" onClick={onClose}>
          Cancel
        </button>
        <button className="btn d-flex" onClick={() => handleSave(sigPad.current.toDataURL())}>
          Save
        </button>
      </div>
    </Modal>
  );
};

export default SignatureModal;
